import React from 'react';
import EnumChange from './EnumChange';

const ComplianceChange = props => {
  const { log } = props;

  return (
    <span>
      <EnumChange log={log} />
    </span>
  );
};

export default ComplianceChange;
